// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"styles_modalContent__dFnZo","title":"styles_title___AHM7","footer":"styles_footer__tBsTh","overFlowVisible":"styles_overFlowVisible__JeOxy"};